import { render, staticRenderFns } from "./OrganizationBillingRequests.vue?vue&type=template&id=6ecec7d4"
import script from "./OrganizationBillingRequests.vue?vue&type=script&lang=js"
export * from "./OrganizationBillingRequests.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports